export default {
    bind(el, binding, vnode) {
        let nestedAccordionEl = el.querySelector('.js-nested-accordion');
        let expandAllBoolean = true;
        let accordionObserver = new window.MutationObserver(observerCallback);
        let toggleAllButton = el.querySelector('.nested-accordion__toggle-all');
        var hashId = (window.location.href.split('#')[1] || '');
        let searchResultLinkedHeading = el.querySelector(`button[aria-controls="${hashId}"]`);
        let parentContainersArray = [];

        if(nestedAccordionEl) {
            accordionObserver.observe(nestedAccordionEl, {
                attributeFilter: ['aria-expanded'],
                attributes: true,
                subtree: true
            });
        }

        if(searchResultLinkedHeading) {
            let parentContainer = getClosest(searchResultLinkedHeading, '.nested-accordion__collapse');

            if(parentContainer) {
                while (parentContainer) {
                    if(parentContainer.previousElementSibling && parentContainer.previousElementSibling.classList && parentContainer.previousElementSibling.classList.contains('nested-accordion__toggle-button')) {
                        parentContainersArray.push(parentContainer.previousElementSibling);
                        parentContainer = getClosest(parentContainer.previousElementSibling, '.nested-accordion__collapse');
                    } else {
                        break;
                    }
                }

                if(parentContainersArray.length) {
                    for (let i = 0; i < parentContainersArray.length; i++) {
                        setTimeout(() => {
                            parentContainersArray[i].click();
                        }, 10);
                    }
                }
            }

            searchResultLinkedHeading.click();
            searchResultLinkedHeading.scrollIntoView();
        }

        window.toggleNestedAccordions = function toggleNestedAccordions() {
            if(expandAllBoolean) {
                expandAll();

                if(toggleAllButton) {
                    toggleAllButton.innerHTML = 'Collapse All <span aria-hidden="true">&minus;</span>';
                }

                expandAllBoolean = false;
            } else {
                collapseAll();

                if(toggleAllButton) {
                    toggleAllButton.innerHTML = 'Expand All <span aria-hidden="true">&plus;</span>';
                }

                expandAllBoolean = true;
            }
        };

        function expandAll() {
            let buttonList = el.querySelectorAll('.js-nested-accordion button.nested-accordion__toggle-button');

            for (let i = 0; i < buttonList.length; i++) {
                if(buttonList[i].attributes.getNamedItem('aria-expanded').value === 'false') {
                    buttonList[i].click();
                }
            }
        }

        function collapseAll() {
            let buttonList = el.querySelectorAll('.js-nested-accordion button.nested-accordion__toggle-button');

            for (let i = 0; i < buttonList.length; i++) {
                if(buttonList[i].attributes.getNamedItem('aria-expanded').value === 'true') {
                    buttonList[i].click();
                }
            }
        }

        function getClosest(elem, selector) {
            for (; elem && elem !== document; elem = elem.parentNode) {
                if(elem.matches(selector)) return elem;
            }

            return null;
        }

        function observerCallback(mutationsList) {
            mutationsList.forEach(node => {
                let target = node.target;
                let parentElement = target.parentElement;
                let lastButtonElement;
                let targetIsLastButtonElement = false;
                let targetIsContainerElement = false;
                let parentCollapseElement = getClosest(target, '.nested-accordion__collapse');
                let lastChildButtonElement;
                let childCardBody;
                let nextParentButtonElement;
                let nextSiblingButton;
                let targetIsExpanded = target.attributes.getNamedItem('aria-expanded').value === 'true';

                if(target.classList.contains('js-transparent-border') && targetIsExpanded) {
                    target.classList.remove('js-transparent-border');
                    target.classList.add('js-transparent-border-off');

                    if(target.nextElementSibling && target.nextElementSibling.classList && target.nextElementSibling.classList.contains('nested-accordion__collapse--content')) {
                        target.nextElementSibling.setAttribute('data-content', '');
                    }
                } else if(target.classList.contains('js-transparent-border-off') && !targetIsExpanded) {
                    target.classList.remove('js-transparent-border-off');

                    if(target.nextElementSibling && target.nextElementSibling.classList && target.nextElementSibling.classList.contains('nested-accordion__collapse--content')) {
                        target.nextElementSibling.removeAttribute('data-content');
                    }
                }

                if(parentElement) {
                    for (let i = parentElement.childNodes.length; i--;) {
                        if(parentElement.childNodes[i].classList && parentElement.childNodes[i].classList.contains('nested-accordion__toggle-button')) {
                            lastButtonElement = parentElement.childNodes[i];
                            break;
                        }
                    }
                }

                if(lastButtonElement) {
                    targetIsLastButtonElement = target.isSameNode(lastButtonElement);
                }

                if(target.nextElementSibling.classList && (target.nextElementSibling.classList.contains('nested-accordion__collapse--container-container') || target.nextElementSibling.classList.contains('nested-accordion__collapse--container'))) {
                    targetIsContainerElement = true;
                }

                if(lastButtonElement && targetIsExpanded && target.nextElementSibling.classList && target.nextElementSibling.classList.contains('nested-accordion__collapse--content')) {
                    if(parentCollapseElement) {
                        nextParentButtonElement = parentCollapseElement.nextElementSibling;

                        if(!nextParentButtonElement && targetIsLastButtonElement) {
                            target.nextElementSibling.setAttribute('data-content', '');
                        }
                    }
                }

                if(target.attributes.getNamedItem('aria-expanded').value === 'true') {
                    targetIsExpanded = true;
                } else {
                    targetIsExpanded = false;
                }

                if(targetIsLastButtonElement && targetIsContainerElement) {
                    childCardBody = target.nextElementSibling.querySelector('.card-body');

                    if(parentCollapseElement) {
                        nextParentButtonElement = parentCollapseElement.nextElementSibling;
                    }

                    if(childCardBody) {
                        for (let i = childCardBody.childNodes.length; i--;) {
                            if(childCardBody.childNodes[i].classList && childCardBody.childNodes[i].classList.contains('nested-accordion__toggle-button')) {
                                lastChildButtonElement = childCardBody.childNodes[i];
                                break;
                            }
                        }

                        if(lastChildButtonElement && lastChildButtonElement.attributes.getNamedItem('aria-expanded').value === 'false') {
                            lastChildButtonElement.classList.add('js-transparent-border');
                        }
                    }
                }

                if(targetIsLastButtonElement && nextParentButtonElement && nextParentButtonElement.classList && nextParentButtonElement.classList.contains('nested-accordion__toggle-button')) {
                    if(targetIsExpanded) {
                        nextParentButtonElement.classList.add('js-hide-after');
                    } else {
                        nextParentButtonElement.classList.remove('js-hide-after');
                    }

                    for (let i = parentCollapseElement.parentNode.children.length; i--;) {
                        if(parentCollapseElement.parentNode.children[i].classList && parentCollapseElement.parentNode.children[i].classList.contains('nested-accordion__toggle-button')) {
                            if(!parentCollapseElement.previousElementSibling.isSameNode(parentCollapseElement.parentNode.children[i]) && !parentCollapseElement.previousElementSibling.parentNode.classList.contains('js-nested-accordion')) {
                                nextParentButtonElement.classList.remove('js-hide-after');
                                break;
                            }
                        }
                    }
                } else if(parentElement.classList && parentElement.classList.contains('js-nested-accordion')) {
                    if(targetIsLastButtonElement && targetIsExpanded) {
                        target.nextElementSibling.setAttribute('data-content', '');
                    } else if(targetIsLastButtonElement && !targetIsExpanded) {
                        target.nextElementSibling.removeAttribute('data-content');
                    }

                    if(target.nextElementSibling && target.nextElementSibling.nextElementSibling) {
                        if(target.nextElementSibling.nextElementSibling.classList && target.nextElementSibling.nextElementSibling.classList.contains('nested-accordion__toggle-button')) {
                            nextSiblingButton = target.nextElementSibling.nextElementSibling;

                            if(targetIsExpanded && nextSiblingButton.isSameNode(lastButtonElement) && nextSiblingButton.attributes.getNamedItem('aria-expanded').value === 'false') {
                                nextSiblingButton.classList.add('js-transparent-border');
                            } else if(!targetIsExpanded && nextSiblingButton.isSameNode(lastButtonElement) && nextSiblingButton.attributes.getNamedItem('aria-expanded').value === 'false') {
                                nextSiblingButton.classList.remove('js-transparent-border');
                            }
                        }
                    }
                }
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/directives/nested-accordion.js